module.exports = __webpack_public_path__ + "media/images/mailer/logo_icon-light-672bcd7769e84836f7c8e2730ff4a4c8.png";